
function Diamond3D(){

    LoadScript.load(mcubeArgs.themeLink + '/js/modules/diamond.js', null);

}